import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useState } from "react";
import constantApi from "../../../constantApi";
import { axios_get, axios_post } from "../../../axios";
import { ToastMassage } from "../../../toast";
import axios from "axios";


export default function Emp_Family() {
  const [formData, setFormData] = useState({
    familyCode: "IT101314",
    familyName: "",
    description: "",
    department: "",
    note1: "",
    note2: "",
    note3: "",
    date1: "",
    date2: "",
    addedBy: "1",
    createdDate: new Date().toLocaleString(),
    status: "Active",
    company: "",
    location: "",
  });
const [isSubmit, setIsSubmit] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };


  
const handleSubmit = async (event) => {
  event.preventDefault();

  try {
    const response = await axios.post(`${constantApi.baseUrl}/emp_dep_fam/store`, formData);
    if (response) {
      if (response.status) {
        ToastMassage(response.message, "success");
        alert("Emp Department family store successfully")

      } else {
        ToastMassage(response.message, "error");
      }
    }
  } catch (error) {
    ToastMassage("Something went wrong!", "error");
    console.error(error);
  }
};

    

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="max-w-6xl mx-auto bg-white p-6 shadow rounded-lg">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
            Add Employee Family
          </h2>
          <button className="bg-gray-100 text-sm px-3 py-1 rounded hover:bg-gray-200 transition">
            BACK
          </button>
        </div>

        {/* Form */}
        <form
          onSubmit={handleSubmit}
          className="grid grid-cols-3 gap-4 text-sm"
        >
          {/* Family Code */}
          <div>
            <label className="block text-gray-600 mb-1">Family Code</label>
            <input
              type="text"
              name="familyCode"
              value={formData.familyCode}
              readOnly
              className="w-full border rounded px-2 py-1 bg-gray-100 text-gray-700 text-sm"
            />
          </div>

          {/* Family Name */}
          <div>
            <label className="block text-gray-600 mb-1">Family Name</label>
            <input
              type="text"
              name="familyName"
              value={formData.familyName}
              onChange={handleChange}
              className="w-full border rounded px-2 py-1 text-sm"
            />
          </div>

          {/* Long Description */}
          <div>
            <label className="block text-gray-600 mb-1">Long Description</label>
            <input
              type="text"
              name="description"
              value={formData.description}
              onChange={handleChange}
              className="w-full border rounded px-2 py-1 text-sm"
            />
          </div>

          {/* Department */}
          <div>
            <label className="block text-gray-600 mb-1">Department Name</label>
            <select
              name="department"
              value={formData.department}
              onChange={handleChange}
              className="w-full border rounded px-2 py-1 text-sm"
            >
              <option value="">Select Department</option>
              <option value="IT">IT</option>
              <option value="HR">HR</option>
              <option value="Finance">Finance</option>
            </select>
          </div>

          {/* Note1 */}
          <div>
            <label className="block text-gray-600 mb-1">Note 1</label>
            <input
              type="text"
              name="note1"
              value={formData.note1}
              onChange={handleChange}
              className="w-full border rounded px-2 py-1 text-sm"
            />
          </div>

          {/* Note2 */}
          <div>
            <label className="block text-gray-600 mb-1">Note 2</label>
            <input
              type="text"
              name="note2"
              value={formData.note2}
              onChange={handleChange}
              className="w-full border rounded px-2 py-1 text-sm"
            />
          </div>

          {/* Note3 */}
          <div>
            <label className="block text-gray-600 mb-1">Note 3</label>
            <input
              type="text"
              name="note3"
              value={formData.note3}
              onChange={handleChange}
              className="w-full border rounded px-2 py-1 text-sm"
            />
          </div>

          {/* Date1 */}
          <div>
            <label className="block text-gray-600 mb-1">Date 1</label>
            <input
              type="date"
              name="date1"
              value={formData.date1}
              onChange={handleChange}
              className="w-full border rounded px-2 py-1 text-sm"
            />
          </div>

          {/* Date2 */}
          <div>
            <label className="block text-gray-600 mb-1">Date 2</label>
            <input
              type="date"
              name="date2"
              value={formData.date2}
              onChange={handleChange}
              className="w-full border rounded px-2 py-1 text-sm"
            />
          </div>

          {/* Added By */}
          <div>
            <label className="block text-gray-600 mb-1">Added By</label>
            <input
              type="text"
              name="addedBy"
              value={formData.addedBy}
              readOnly
              className="w-full border rounded px-2 py-1 bg-gray-100 text-gray-700 text-sm"
            />
          </div>

          {/* Created Date */}
          <div>
            <label className="block text-gray-600 mb-1">Created Date</label>
            <input
              type="text"
              name="createdDate"
              value={formData.createdDate}
              readOnly
              className="w-full border rounded px-2 py-1 bg-gray-100 text-gray-700 text-sm"
            />
          </div>

          {/* Status */}
          <div>
            <label className="block text-gray-600 mb-1">Status</label>
            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
              className="w-full border rounded px-2 py-1 text-sm"
            >
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>

          {/* Company */}
          <div>
            <label className="block text-gray-600 mb-1">Company</label>
            <select
              name="company"
              value={formData.company}
              onChange={handleChange}
              className="w-full border rounded px-2 py-1 text-sm"
            >
              <option value="">Select Company</option>
              <option value="JTS">JTS</option>
              <option value="Other">Other</option>
            </select>
          </div>

          {/* Location */}
          <div>
            <label className="block text-gray-600 mb-1">Location</label>
            <select
              name="location"
              value={formData.location}
              onChange={handleChange}
              className="w-full border rounded px-2 py-1 text-sm"
            >
              <option value="">Select Location</option>
              <option value="Dubai">Dubai</option>
              <option value="Abu Dhabi">Abu Dhabi</option>
            </select>
          </div>

          {/* Buttons inside form */}
          <div className="col-span-3 flex justify-end gap-3 mt-6">
            <button
              type="submit"
              className="bg-blue-600 text-white text-sm px-5 py-1.5 rounded hover:bg-blue-700 transition"
            >
              SAVE
            </button>
            <button
              type="button"
              className="bg-gray-600 text-white text-sm px-5 py-1.5 rounded hover:bg-gray-700 transition"
            >
              CANCEL
            </button>
          </div>
        </form>
      </div>
    </DashboardLayout>
  );
}
